import styled from 'styled-components';

const BoxInformativo = styled.div`
img {
    filter: inherit !important;
    margin-right: 10px;
    width: 5%;
  }
  p.strong {
    font-weight: bold !important;
    font-size: 12px !important;
  }
.error-controlado hr{
    margin-top: 0;
      margin-bottom: 1rem;
  }
  section.error-controlado {
    padding-bottom: 25px;
  }
  .contenedor-informacion-error {
    background-color: #F9D4D5;
    padding: 9px;
    margin: 0 23px;
    display: flex;
    align-items: flex-start;
  }
  .contenedor-informacion-error button {
    color: #BF0239 !important;
    font-size: 0.7rem;
    padding: 0;
    min-height: 33px;
}
  .contenedor-informacion-error p {
    color: #BF0238;
    font-size: 10px;
    font-weight: 400;
    line-height: 18px;
  }

  .timerimg{
    margin-left: auto;
  }

  .contentido{
    margin-top:5px;
  }

  @media (max-width: 426px){
    p.strong {
      font-size: 10px !important;
    }
    .row-detalle p {
      font-size: 11px;
    }
    .contenedor-informacion-error button {
      font-size: 0.6rem !important;
    }
    img.sin-saldo-tarjeta {
      margin-left: 106px;
    }
  }

  @media (max-width: 376px){
    p.strong {
      font-size: 9px !important;
    }
    .row-detalle p {
      font-size: 10px;
    }
    img.sin-saldo-tarjeta {
      margin-left: 79px;
    }
  }

  @media (max-width: 321px){
    p.strong {
      font-size: 9px !important;
    }
    .contenedor-informacion-error p {
      font-size: 9px;
    }
    
    .row-detalle p {
      font-size: 10px;
    }
    img {
      width: 6%;
    }
    img.sin-saldo-tarjeta {
      margin-left: 22px;
    }
  }
`;

export default BoxInformativo;